/**
 * Cones BOGO cart-drawer notice.
 *
 * Two jobs:
 *   1. The inline "add one more" action at the one-away prompt.
 *   2. Keeping the notice current when a line quantity changes.
 *
 * Adding to cart already re-renders the whole <cart-drawer> element, which
 * carries the notice with it. Quantity changes inside the drawer do not, so
 * the notice refreshes itself from the theme's own on:line-item:change event
 * rather than requiring an entry in cart-items.js getSectionsToRender().
 *
 * Both listeners are delegated to document, so they survive every re-render.
 */
if (!window.conesBogoNoticeReady) {
  window.conesBogoNoticeReady = true;

  const SECTION = 'cones-bogo-notice';
  const SELECTOR = '.cones-bogo-notice';

  /**
   * Re-renders the notice from its section.
   */
  const refresh = async () => {
    const target = document.getElementById('cones-bogo-notice');
    if (!target) return;

    try {
      const response = await fetch(`?sections=${SECTION}`);
      if (!response.ok) return;

      const data = await response.json();
      const tmpl = document.createElement('template');
      tmpl.innerHTML = data[SECTION];

      const fresh = tmpl.content.querySelector(SELECTOR);
      target.innerHTML = fresh ? fresh.innerHTML : '';
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  document.addEventListener('on:line-item:change', refresh);

  document.addEventListener('click', async (evt) => {
    const button = evt.target.closest('[data-cones-add-one]');
    if (!button) return;

    evt.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const cartDrawer = document.querySelector('cart-drawer');
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');

    try {
      const sections = cartDrawer
        ? [...new Set(cartDrawer.getSectionsToRender().map((section) => section.section))]
        : [];

      const response = await fetch(window.theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript'
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections,
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || response.status);

      if (cartDrawer) {
        const sectionId = cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');

        // The drawer is already open, so re-render in place rather than
        // re-opening it. Cart POST endpoints render sections against the
        // PUBLISHED theme, so on an unpublished preview this section is null
        // and we fall back to the drawer's GET-based refresh.
        if (data.sections && data.sections[sectionId]) {
          cartDrawer.renderContents(data, false);
        } else {
          await cartDrawer.refresh(true);
        }
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.log(error); // eslint-disable-line
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-loading');
    }
  });
}
